import homeVideo from "fragments/homeVideos/homeVideo"
import gql from "graphql-tag"

const ADD_HOME_VIDEO = gql`
  ${homeVideo}

  mutation addHomeVideo(
    $homeVideoAddInput: HomeVideoAddInput!
    $newsIds: [ID!]
    $homeVideoReviewIds: [ID!]
    $storeLinksAddInput: [StoreLinkAddInput]
  ) {
    addHomeVideo(
      homeVideoAddInput: $homeVideoAddInput
      newsIds: $newsIds
      homeVideoReviewIds: $homeVideoReviewIds
      storeLinksAddInput: $storeLinksAddInput
    ) {
      ...HomeVideo
    }
  }
`

export default ADD_HOME_VIDEO
